export const CREATE_CONTACT = "CREATE_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const GET_CONTACT = "GET_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const SELECT_ALL_CONTACT = "SELECT_ALL_CONTACT";
export const CLEAR_ALL_CONTACT = "CLEAR_ALL_CONTACT";
export const DELETE_SELECTED_CONTACT = "DELETE_SELECTED_CONTACT";